import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/App/ErrorBoundary/index';
import * as serviceWorker from './serviceWorker';

import theme from './_shared/themes';
import GlobalStyle from './assets/styles/GlobalStyle';

import App from './components/App/index';
import store from './store';
import { browserHistory } from './components/Routes';

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <Router history={browserHistory}>
            <App />
          </Router>
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>,
    document.getElementById('root')
  );
};

render();
// If you want your App to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./components/App/index', render);
}

/* eslint-disable func-names */
document.body.addEventListener('mousedown', function() {
  document.body.classList.add('using-mouse');
});

document.body.addEventListener('keydown', function(event) {
  if (event.code === 'Tab') {
    document.body.classList.remove('using-mouse');
  }
});
